import _ from 'lodash'

// The renders of a summary (the client's copy on Send, the Download PDF) read
// the SAVED summary, but the page rebuilds the AEP cards in memory on load
// without saving them (summary 16517, 2026-10-13: three titles-only copies).
// An agent's render saves the summary on screen first. False when that save
// failed: render nothing then.
export async function saveSummaryOnScreen (vm, summaryId) {
    const onScreen = vm.$store.state?.summary
    if (!vm.canAgent || onScreen?.id !== summaryId || !onScreen.data) {
        return true
    }
    const { error } = await vm.$try('updateSummary', { id: summaryId, data: _.cloneDeep(onScreen.data) })
    return !error
}
